export default class AddToCartOverlay{
    show: boolean;
    regionLocked: boolean;
}